'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require('abortable-iterator'),
    abortable = _require.source;

var debug = require('debug');

var log = debug('libp2p:stream:converter');
/**
 * @typedef {import('multiaddr').Multiaddr} Multiaddr
 * @typedef {import('libp2p-interfaces/src/stream-muxer/types').MuxedStream} MuxedStream
 *
 * @typedef {Object} Timeline
 * @property {number} open - connection opening timestamp.
 * @property {number} [upgraded] - connection upgraded timestamp.
 * @property {number} [close]
 */

/**
 * Convert a duplex iterable into a MultiaddrConnection.
 * https://github.com/libp2p/interface-transport#multiaddrconnection
 *
 * @param {object} streamProperties
 * @param {MuxedStream} streamProperties.stream
 * @param {Multiaddr} streamProperties.remoteAddr
 * @param {Multiaddr} streamProperties.localAddr
 * @param {object} [options]
 * @param {AbortSignal} [options.signal]
 * @returns {import('libp2p-interfaces/src/transport/types').MultiaddrConnection}
 */

function streamToMaConnection(_ref) {
  var stream = _ref.stream,
      remoteAddr = _ref.remoteAddr,
      localAddr = _ref.localAddr;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _sink = stream.sink,
      source = stream.source;
  var maConn = {
    /**
     * @param {Uint8Array} source
     */
    sink: function sink(source) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (options.signal) {
                  // @ts-ignore ts infers source template will be a number
                  source = abortable(source, options.signal);
                }

                _context.prev = 1;
                _context.next = 4;
                return _sink(source);

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](1);

                // If aborted we can safely ignore
                if (_context.t0.type !== 'aborted') {
                  // If the source errored the socket will already have been destroyed by
                  // toIterable.duplex(). If the socket errored it will already be
                  // destroyed. There's nothing to do here except log the error & return.
                  log(_context.t0);
                }

              case 9:
                _close();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 6]]);
      }))();
    },
    source: options.signal ? abortable(source, options.signal) : source,
    conn: stream,
    localAddr: localAddr,
    remoteAddr: remoteAddr,

    /** @type {Timeline} */
    timeline: {
      open: Date.now(),
      close: undefined
    },
    close: function close() {
      _sink(new Uint8Array(0));

      return _close();
    }
  };

  function _close() {
    if (!maConn.timeline.close) {
      maConn.timeline.close = Date.now();
    }

    return Promise.resolve();
  }

  return maConn;
}

module.exports = streamToMaConnection;